devs-gen-calendar
  .line(each="{cells in this.ary}")
    .cell-wrap(each="{cell in cells}")
      .month(if="{cell.isShowMonth}") { cell.month }
      .month(if="{!cell.isShowMonth}")
      .day(class="day_{ cell.week }")
        span { cell.day }
      .cell(class="cell_{ cell.week }") &nbsp;
  script(type="typescript").
    this.mixin('devs.gen-calendar');
